import React, { useMemo } from 'react'
import { Box, Stack, Typography, useTheme, Button } from '@mui/material'
import { styled } from '@mui/system'

const StyledWidgetSingleInformation = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  position: 'relative',
  height: '100%',
  cursor: 'pointer'
}))

const IconContainer = styled(Box)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.primary.main,
  marginLeft: theme.spacing(1),
  position: 'relative',
  top: '4px'
}))

const LandscapeContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%'
}))

const ActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#F6F6F6',
  borderRadius: '8px',
  width: '24px',
  minHeight: '32px',
  marginLeft: theme.spacing(1),
  color: theme.palette.primary.main,
  '& > i': {
    fontWeight: 900
  },
}))

const WidgetSingleInformation = ({
  number,
  icon,
  text,
  actionIcon,
  landscapeView = false,
  onClick = () => {}
}) => {
  const theme = useTheme()
  const { palette } = theme

  const formattedNumber = useMemo(() => {
    return new Intl.NumberFormat().format(number)
  }, [number])

  return (
    <StyledWidgetSingleInformation onClick={onClick}>
      {landscapeView ? (
        <LandscapeContainer>
          <Stack direction="row" alignItems="center" spacing={2.5}>
            <Stack direction="row" alignItems="start" spacing={1}>
              <Typography fontSize={32} fontWeight={200}>{formattedNumber}</Typography>
              <IconContainer>
                <i className={icon} />
              </IconContainer>
            </Stack>
            <Typography fontSize={14} color={palette.grey[600]}>{text}</Typography>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={1}>
            {actionIcon && (
              <ActionButton onClick={onClick}>
                <i className={actionIcon} />
              </ActionButton>
            )}
          </Stack>
        </LandscapeContainer>
      ) : (
        <>
          <Stack direction="row" alignItems="start" spacing={1}>
            <Typography fontSize={32} fontWeight={200}>{formattedNumber}</Typography>
            <IconContainer>
              <i className={icon} />
            </IconContainer>
            <Typography color={palette.grey[600]} sx={{fontSize: '14px', alignSelf: 'center'}}>{text}</Typography>
          </Stack>
        </>
      )}
    </StyledWidgetSingleInformation>
  )
}

export default WidgetSingleInformation
